<template>
  <el-row type="flex" class="row-bg" justify="center" v-if="activity">
    <div class="grid-content bg-purple-dark">
      <div class="box">
        <el-row type="flex" class="row-bg" justify="center" align="middle" style="width: 100%; max-height: 280px;overflow: hidden;position: relative;">
          <img :src="thumb" style="width: 100%;height: auto;">
        </el-row>
        <!--
        <div class="thumb flex"
             justify="center"
             :style="{'background-image':'url('+thumb+')'}">
          <div class="endTips" v-if="false">
            <div class="text">距截稿</div>
            <el-row type="flex" justify="center" align="top">
              <div class="day">111</div>
              <div class="tian">天</div>
            </el-row>
          </div>

        </div>
        -->
        <div class="info">
          <div class="isAward" v-if="activity.isAward==1"></div>
          <div class="title text-cut2">{{activity.activityName}}</div>
          <el-row type="flex" style="margin: 10px 0;">
            <div class="owner">发起人</div>
            <div class="owner-text">{{activity.sponsor||''}}</div>
          </el-row>
          <!--
          <div class="desc text-cut2" v-if="activity.description">{{activity.description.replace(/\&[^;]+;/g,'')}}</div>
          -->
        </div>
      </div>
      <brand style="margin-top: 50px;" :activity="activity"></brand>
      <wxlite class="hidden-sm-and-up" :activity="activity">
        查看详情
      </wxlite>
    </div>
  </el-row>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  //import 'element-ui/lib/theme-chalk/display.css';
  export default {
    name: 'activity',
    data () {
      return {
        thumb:'',
        activity:null,
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{
      getDetail(){
        App.Contribution.GetContributionById({id:this.id}).then(res=>{
          if(res.code!=200) return this.$message({
            type:'error',
            message:'咦...链接不正确或网络不稳定，请检查后重试!',
            duration:-1,
          })
          res.data.description=(res.data.description||'').replace(/<[^>]+>/g,'')
          if(res.data.activityCovers[0].materialType== "VideoMaterialType"){
            this.thumb=res.data.activityCovers[0].url+'?vframe/jpg/offset/1'
          }else{
            this.thumb=res.data.activityCovers[0].url+'?imageMogr2/thumbnail/750x/quality/100!/ignore-error/1/crop/750x520';
          }
          this.activity=res.data
          this.activity.thumb=this.thumb
          this.adinit()
        })
      },
      adinit(params={}){
        if(this.activity.activityAuth.isAdvertisement==1) return;
        // 全局命名空间申明TencentGDT对象
        window.TencentGDT = window.TencentGDT || [];
        // 广告初始化
        window.TencentGDT.push({
          app_id: '1207383851', // {String} - appid - 必填
          placement_id: '9142009522043212', // {String} - 广告位id - 必填
          type: 'interstitial', // {String} - 原生广告类型 - 必填
          //muid_type: '1', // {String} - 移动终端标识类型，1：imei，2：idfa，3：mac号 - 选填
          //muid: '******', // {String} - 加密终端标识，详细加密算法见API说明 -  选填
          count: 1, // {Number} - 拉取广告的数量，默认是3，最高支持10 - 选填
          onComplete: function(res) {
            console.log('adinit.onComplete',res)
            if (res && res.ret === 0) {
              // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
              // res[0] 代表取广告数组第一个数据
              TencentGDT.NATIVE.renderAd(res.data[0]);
            } else {
              // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
              // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率
              setTimeout(function() {
                window.TencentGDT.NATIVE.loadAd('9142009522043212')
              }, 3000)
            }
          }
        });

        // H5 SDK接入全局只需运行一次
        (function () {
          var doc = document,
            h = doc.getElementsByTagName('head')[0],
            s = doc.createElement('script');
          s.async = true;
          s.src = 'https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js';
          h && h.insertBefore(s, h.firstChild)
        })();
      },
    },
    mounted(){
      console.log(this.$route.params.id)
      this.id=this.$route.params.id.replace(/[&].*/i,'');
      this.getDetail()
    },

  }
</script>

<style scoped>
  .bg-purple-dark {
    background: #ffffff;
    max-width: 375px;
    min-width: 345px;
    box-sizing: border-box;
    margin: 50px auto 10px;
    overflow-x: hidden;
  }
  .box{
    width: 335px;
    opacity: 1;
    background: linear-gradient(180deg,#ffffff, #ffffff 100%);
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0px rgba(208,207,207,0.50);
    margin: 0 auto;
  }
  .thumb{
    width: 335px;
    height: 280px;
    opacity: 1;
    background-size: cover;
    position: relative;
  }
  .isAward{
    position: absolute;
    top:-13px;
    left: 10px;
    z-index: 9;

    width: 75px;
    height: 18px;
    opacity: 1;
    background: #ffefef;
    border: 1px solid #ffffff;
    border-radius: 3px 13px 2px 3px;
    background-image: url("https://assets.pfotoo.com/images/%E6%9C%89%E5%A5%96%E5%BE%81%E9%9B%86%E5%B8%A6%E6%96%87%E5%AD%97.svg");
    background-size: 100% 100%;
    box-sizing: border-box;
  }
  .endTips{
    position: absolute;
    top:0;
    left: 0;
    width: 35px;
    height: 60px;
    opacity: 1;
    background-size: 100% 100%;
    background-image: url("https://qn002.pfotoo.com/image/%E8%B7%9D%E6%88%AA%E7%A8%BF.svg");
  }
  .endTips .text{
    height: 14px;
    opacity: 1;
    font-size: 10px;
    font-family: PingFangSC, PingFangSC-Light;
    font-weight: 300;
    text-align: left;
    color: #ffffff;
    line-height: 14px;
    margin-top: 7px;
    margin-bottom: 3px;
    white-space:nowrap;
  }
  .endTips .day{
    height: 22px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 22px;
  }
  .endTips .tian{
    width: 10px;
    height: 14px;
    opacity: 1;
    font-size: 10px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 14px;
    margin-top: 5px;
  }
  .info{
    box-sizing: border-box;
    padding: 10px 10px 30px;
    position: relative;
  }
  .text-cut2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .title{
    opacity: 1;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #5d5d5d;
    line-height: 25px;
  }
  .desc{
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 20px;
  }
  .owner{
    width: 40px;
    height: 15px;
    opacity: 1;
    background: #f3f9f9;
    border-radius: 2px;

    opacity: 1;
    font-size: 10px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3dc4a7;
    line-height: 15px;
  }
  .owner-text{
    height: 17px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 17px;
    margin-left: 5px;
  }
  .hidden-sm-and-up{
    margin: 42px auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity.vue